import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatSelect, MatSelectModule } from '@angular/material/select';
import { ProfileAvatarComponent } from '../../profile-avatar/profile-avatar.component';
import { Router } from '@angular/router';
import { PermissionsService } from '../../../../core/services/permissions/permissions.service';
import { Subscription } from 'rxjs';
import { TranslatePipe } from '@ngx-translate/core';
import { DepartmentWithResidents } from '../../../models/department.model';
import { ShopSelectionStore } from '../../../../core/state/shop-selection.store';

@Component({
  selector: 'app-web-header-dropdown',
  templateUrl: './web-header-dropdown.component.html',
  styleUrls: ['./web-header-dropdown.component.scss'],
  imports: [
    MatSelectModule,
    MatIconModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    TranslatePipe,
    ProfileAvatarComponent,
  ],
})
export class WebHeaderDropdownComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  @Input() label!: string;
  @Input() control!: FormControl;
  @Input() options: any[] = [];
  @Input() panelClass = 'select-panel-thick';
  @Input() showSearch = false;
  @Input() searchPlaceholder = 'Search...';
  @Input() useGetName: boolean = false;
  @Input() filterControl = new FormControl('');
  @Input() optionTemplate!: TemplateRef<any>;
  @Input() selectedId: number;
  @Input() isResidentDropdown: boolean = false;
  @Output() selectionChange = new EventEmitter<any>();
  @Output() backdropChanged = new EventEmitter<boolean>();
  @ViewChild('select', { static: true }) matSelect!: MatSelect;
  @ViewChild('filterInput') filterInput!: ElementRef;

  customerSubscription: Subscription = new Subscription();
  departmentSubscription: Subscription = new Subscription();

  selectedCustomerId: number | null = null;
  selectedDepartment: DepartmentWithResidents | null = null;

  constructor(
    private router: Router,
    private shopSelectionStore: ShopSelectionStore,
    public permissionsService: PermissionsService
  ) {}

  private wheelEventHandler = (event: Event) => {
    event.preventDefault();
  };

  ngOnInit(): void {
    this.customerSubscription = this.shopSelectionStore.customer$.subscribe(
      customer => {
        if (customer) {
          this.selectedCustomerId = customer.id;
        }
      }
    );

    this.departmentSubscription = this.shopSelectionStore.department$.subscribe(
      department => {
        if (department) {
          this.selectedDepartment = department;
        }
      }
    );
  }

  ngAfterViewInit(): void {
    this.matSelect.openedChange.subscribe(isOpen => {
      if (isOpen) {
        this.filterControl.setValue('');
        document
          .getElementById('dropdownField')
          ?.addEventListener('wheel', this.wheelEventHandler, {
            passive: false,
          });
      } else {
        document
          .getElementById('dropdownField')
          ?.removeEventListener('wheel', this.wheelEventHandler);
      }
      this.backdropChanged.emit(isOpen);
    });
  }

  shouldBeHidden(option: any): boolean {
    const filterValue = this.filterControl.value.toLowerCase();
    return this.useGetName
      ? !option
          .getName()
          .toLowerCase()
          .split(' ')
          .some(word => word.startsWith(filterValue))
      : !option.name
          .toLowerCase()
          .split(' ')
          .some(word => word.startsWith(filterValue));
  }

  compareFunction(option1: any, option2: any): boolean {
    if (this.isResidentDropdown) {
      return option1 && option2
        ? option1.id === option2.id
        : option1 === option2;
    } else
      return option1 && option2
        ? option1.departmentId === option2.departmentId
        : option1 === option2;
  }

  ngOnDestroy(): void {
    if (this.customerSubscription) {
      this.customerSubscription.unsubscribe();
    }
    if (this.departmentSubscription) {
      this.departmentSubscription.unsubscribe();
    }
    document
      .getElementById('dropdownField')
      ?.removeEventListener('wheel', this.wheelEventHandler);
  }

  listFilterClick(event: MouseEvent): void {
    event.stopPropagation();
  }
  closeSelect(e: Event): void {
    if (this.matSelect.panelOpen) {
      e.stopPropagation();
    }
    this.matSelect.close();
  }

  getIcon() {
    return this.isResidentDropdown ? 'user-icon' : 'department_icon';
  }

  addResident(): void {
    this.router.navigate(['/residents/new'], {
      queryParams: {
        departmentId: this.selectedDepartment?.id,
        customerId: this.selectedCustomerId,
        fromDropdown: true,
      },
    });
  }
}
